import script from "./cdw.vue?vue&type=script&setup=true&lang=js"
export * from "./cdw.vue?vue&type=script&setup=true&lang=js"

import "./cdw.vue?vue&type=style&index=0&id=082c1876&lang=less"

const __exports__ = script;

export default __exports__